export const GET_WELFARE_PROCESS = "GET_WELFARE_PROCESS";
export const UPDATE_WELFARE_PROCESS = "UPDATE_WELFARE_PROCESS";
export const CREATE_SUBSCRIPTION = "CREATE_SUBSCRIPTION";
export const ADD_VISIT = "ADD_VISIT";
export const GET_VISITS = "GET_VISITS";
export const GET_DASHBOARD_DATA = "GET_DASHBOARD_DATA";

